import React, { Fragment, useState } from 'react'
import { Button } from 'react-bootstrap'
import MEModal from '../../components/MEModal'
import { useStateValue } from '@State'
import { bulkFixLmsIds } from '../actions'
import { toast } from '@CommonComponents/toast'

export const BulkFixLmsId = () => {
  const [currentState] = useStateValue()
  const [modalOpen, setModalOpen] = useState(false)

  const toggleModal = () => {
    setModalOpen(!modalOpen)
  }

  const bulkFixModalContent = (authorized) => {
    if (authorized) {
      return (
        <Fragment>
          <p>Attempt to resolve the Canvas IDs for all students?</p>
          <form onSubmit={e => e.preventDefault()}>
            <Button
              type="submit"
              className="btn-myed btn-primary-myed"
              variant="primary"
              onClick={submit}
            >
              Yes
            </Button>
            <Button
              type="submit"
              className="btn-myed btn-default-myed"
              variant="secondary"
              onClick={toggleModal}
            >
              No
            </Button>
          </form>
        </Fragment>
      )
    } else {
      let authLink = `/links/client_canvas.authorize_from_people/${currentState.coursenum}/`
      return (
        <Fragment>
          <h5 className="text-danger">Warning:</h5>
          <p>
            This course is not authorized with Canvas yet. You must authorize
            before continuning by clicking the button below.
          </p>
          <div className="text-center">
            <Button
              className="btn-myed btn-primary-myed"
              variant="primary"
              href={authLink}
            >
              Authorize
            </Button>
          </div>
        </Fragment>
      )
    }
  }

  const submit = async (e) => {
    e.preventDefault()
    toggleModal()

    let resp = await bulkFixLmsIds()

    if (resp.status === 204) {
      toast.info("We have started bulk updating IDs, a completed task will appear once we are done.")
    } else {
      toast.error("There was an error trying to bulk update student IDs.")
    }
  }

  if (currentState.courseLms) {
    return (
      <Fragment>
        <Button variant="link" onClick={toggleModal}>
          <i className="fa-light fa-fw fa-tools" /> Bulk Fix Lms IDs
        </Button>
        <MEModal
          show={modalOpen}
          close={toggleModal}
          title="Confirm"
        >
          {bulkFixModalContent(currentState.authorized)}
        </MEModal>
      </Fragment>
    )
  } else {
    return null
  }
}
